module.exports = false;




//////////////////
// WEBPACK FOOTER
// ./~/detect-node/browser.js
// module id = 1643
// module chunks = 0